import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = (theme) => ({
  root: {
    width: '100%',
    borderRadius: theme.radius.md,
    color: theme.palette.facet.primaryBlue,
    backgroundColor: theme.palette.facet.accentBlue21,
    textAlign: 'center',
    justifyContent: 'center',
    margin: theme.spacing(0, 0, 2, 0),
    '& .MuiRadio-root': { // <--- Hides the default radio input
      opacity: 0,
      position: 'fixed',
      width: 0,
    },
    '& .Mui-checked + .MuiTypography-root': { // <--- Applies "selected" styling to our label
      width: '100%',
      borderRadius: theme.radius.md,
      color: theme.palette.common.white,
      backgroundColor: theme.palette.facet.accentBlue2, // <--- TODO: Update when design spec is finalized
      transition: 'background-color 0.3s ease-in-out',
    },
  },
  formControlLabel: {
    padding: theme.spacing(3.5, 1.5),
  },
});

const RadioButton = ({
  className,
  classes,
  value,
  label,
  ...rest
}) => {
  return (
    <FormControlLabel
      className={classNames(classes.root, className)}
      control={(
        <Radio
          className={classes.formControlRadioButton}
          value={value}
        />)
      }
      label={(
        <Typography
          className={classes.formControlLabel}
          weight={'bold'}
          variant={'h5'}
        >
          {label}
        </Typography>)
      }
      {...rest}
    />
  );
};

RadioButton.defaultProps = {
  className: '',
};

RadioButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default withStyles(styles)(RadioButton);
